// extracted by mini-css-extract-plugin
export default {"container":"Leads_container__0yzM-","page":"Leads_page__2s3p+","header":"Leads_header__weohZ","period":"Leads_period__ArpYO","funnel":"Leads_funnel__oYc2H"};